import type { EmblaCarouselType } from "embla-carousel";

/** True when the carousel has more than one scroll snap (content overflows viewport). */
export function isExclusiveCarouselScrollable(
	api: EmblaCarouselType | undefined,
): boolean {
	if (!api) {
		return false;
	}
	return api.scrollSnapList().length > 1;
}

/** Wrap to last snap when Embla loop is unavailable (few slides vs viewport). */
export function scrollExclusiveCarouselPrev(api: EmblaCarouselType): void {
	if (api.canScrollPrev()) {
		api.scrollPrev();
		return;
	}
	const lastIndex = api.scrollSnapList().length - 1;
	if (lastIndex >= 0) {
		api.scrollTo(lastIndex);
	}
}

/** Wrap to first snap when Embla loop is unavailable (few slides vs viewport). */
export function scrollExclusiveCarouselNext(api: EmblaCarouselType): void {
	if (api.canScrollNext()) {
		api.scrollNext();
		return;
	}
	api.scrollTo(0);
}
